import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicExamples, ClickIt } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import SweetAlert from "sweetalert2";
import { BASIC_SWEETALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const BasicExample = () => {
  const displayAlert = () => {
    SweetAlert.fire({ title: "Welcome! to the Boho theme",confirmButtonColor:"#33BFBF" });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={BasicExamples} span={BASIC_SWEETALERT} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="sweet-1" type="button" onClick={displayAlert}>{ClickIt}</Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicExample;
